export default __webpack_public_path__ + "static/media/poultory.034dedc5.jpg";